export const clearFields = (form) => {

    // SEKCJA SPOSÓB REALIZACJI

    //Samodzielnie
    if (form?.czy_partnerstwo !== 'Tak') {
        delete form?.realizacja_samodzielna
    }

    // Partnerstwo
    if (form?.czy_partnerstwo !== 'Tak') {
        delete form?.czy_wnioskodawca_liderem
        delete form?.partnerstwo_lider_regon
        delete form?.partnerstwo_lider_nazwa
        delete form?.partnerstwo_lider_telefon
        delete form?.partnerstwo_lider_email
        delete form?.partner_list
    }

    if (form?.czy_wnioskodawca_liderem === 'Tak') {
        delete form?.partnerstwo_lider_regon
        delete form?.partnerstwo_lider_nazwa
        delete form?.partnerstwo_lider_telefon
        delete form?.partnerstwo_lider_email
    }

    // Realizatorzy
    if (form?.czy_z_realizatorami !== 'Tak'){
        delete form?.realizator_list
        delete form?.realizator_regon
        delete form?.realizator_nazwa
        delete form?.realizator_telefon
        delete form?.realizator_email
    }

    // Komitet sterujący - #8647
    // if (form?.kategoria === 'B' && form?.czy_komitet !== 'Tak'){
    //     delete form?.przewodniczacy_imie
    //     delete form?.przewodniczacy_nazwisko
    //     delete form?.przewodniczacy_stanowisko
    //     delete form?.przewodniczacy_telefon
    //     delete form?.przewodniczacy_email
    //     delete form?.czlonkowie_list
    // }

    // SEKCJA ZadaniaIT
    const symbol = form?.profile_symbol || '';
    const isDepartment = symbol === 'D';
    const isUnit = !isDepartment

    if (form?.czy_zadania_it !== 'Tak') {
        // departament
        delete form?.ci_opinia_realizacja
        delete form?.ci_data_opinii
        delete form?.ci_numer_pisma
        delete form?.zakres_it_list
        delete form?.wymagane_sla
        delete form?.czy_realizacja_it_firma_zewnetrzna
        delete form?.opis_oprogramowanie_it
        delete form?.czy_utrzymanie_it_firma_zewnetrzna
        delete form?.opis_sprzet_it
        delete form?.ci_opinia_utrzymanie
        delete form?.dostep_zewn_do_infr_it_urzedu
        delete form?.ci_data_przekazania_utrzymania
        delete form?.ci_plan_przekazania_utrzymania

        // Jednostka
        delete form?.jednostka_zakres_list
        delete form?.jednostka_opis_zakresu
        delete form?.jednostka_wygaszenie
        delete form?.jednostka_data_zakonczenia
        delete form?.jednostka_plan_po_trwalosci
    }

    if (isUnit) {
        // czyścimy wszystkie pola Departamentu
        delete form?.ci_opinia_realizacja
        delete form?.ci_data_opinii
        delete form?.ci_numer_pisma
        delete form?.wymagane_sla
        delete form?.czy_realizacja_it_firma_zewnetrzna
        delete form?.opis_oprogramowanie_it
        delete form?.czy_utrzymanie_it_firma_zewnetrzna
        delete form?.opis_sprzet_it
        delete form?.ci_opinia_utrzymanie
        delete form?.dostep_zewn_do_infr_it_urzedu
        delete form?.ci_data_przekazania_utrzymania
        delete form?.ci_plan_przekazania_utrzymania
    }

    if (isDepartment) {
        // czyścimy wszystkie pola Jednostki Podległej
        delete form?.jednostka_zakres_list
        delete form?.jednostka_opis_zakresu
        delete form?.jednostka_wygaszenie
        delete form?.jednostka_data_zakonczenia
        delete form?.jednostka_plan_po_trwalosci
    }

    if (isDepartment) {
        // O.2
        if (form?.ci_opinia_realizacja !== 'Tak') {
            delete form?.ci_data_opinii // O.3
            delete form?.ci_numer_pisma // O.4
            delete form?.zakres_it_list // O.5
            delete form?.wymagane_sla // O.14
            delete form?.czy_realizacja_it_firma_zewnetrzna // O.6
            delete form?.opis_oprogramowanie_it // O.7
            delete form?.czy_utrzymanie_it_firma_zewnetrzna // O.8
            delete form?.opis_sprzet_it // O.9
            delete form?.ci_opinia_utrzymanie // O.10
            delete form?.ci_data_przekazania_utrzymania // O.11
            delete form?.ci_plan_przekazania_utrzymania // O.12
            delete form?.dostep_zewn_do_infr_it_urzedu // O.13
        }

        const zakresITNames = Array.isArray(form?.zakres_it_list)
            ? form.zakres_it_list.map(item => item.slownik_zakres_it_nazwa)
            : [];

        const maOprogramowanie = zakresITNames.includes('Oprogramowanie') ||
            zakresITNames.includes('Licencje, abonamenty, plany');

        const maSprzet = zakresITNames.includes('Sprzęt');

        if (!maOprogramowanie) {
            delete form?.czy_realizacja_it_firma_zewnetrzna // O.6
            delete form?.opis_oprogramowanie_it // O.7
        }

        if (!maSprzet) {
            delete form?.czy_utrzymanie_it_firma_zewnetrzna // O.8
            delete form?.opis_sprzet_it // O.9
        }

        if (form?.czy_realizacja_it_firma_zewnetrzna !== 'Tak' && form?.czy_utrzymanie_it_firma_zewnetrzna !== 'Tak') { //O.6 & //O.8
            delete form?.dostep_zewn_do_infr_it_urzedu // O.13
            delete form?.ci_opinia_utrzymanie // O.10
        }

        if (form?.ci_opinia_utrzymanie !== 'Tak') { //O.10
            delete form?.ci_data_przekazania_utrzymania //O.11
            delete form?.ci_plan_przekazania_utrzymania //O.12
        }
    }

    if (form?.jednostka_wygaszenie === 'Tak') {
        delete form?.jednostka_plan_po_trwalosci
    }

    // SEKCJA Ochrona danych
    if (form?.czy_przetwarzanie_danych !== 'Tak') {
        delete form?.czy_inspektor_ochrony_danych
    }


    return form
}

export class CLEAR_KP {
    dane(form) {
        form = clearFields(form)
        return form
    }
}